import store from '../store'
import {isOverflown} from './'
export default {
    methods: {
        loginRedirects(){
            if(this.$vuetify.breakpoint.mdAndUp){
                (this.$route.path === "/login" || this.$route.path === "/register") && this.$router.push('/')  
                if(store.getters.themes.length){
                    store.commit('CLOSE_POPUP') 
                }else{
                    store.commit('OPEN_POPUP', "Add")
                }                         
            }else{
                if(store.getters.themes.length){
                    (this.$route.path === "/login" || this.$route.path === "/register") && this.$router.push('/')
                    store.commit('CLOSE_POPUP') 
                }else{
                    this.$router.push('/themes') 
                    store.commit('OPEN_POPUP', "Add")
                }                         
            }             
        },
        isOverflown(elem){
            return isOverflown(elem)
        } 
    },   
}